'use strict';

var NotificationService = require('../services/notification-service');
var HTTPService = require('../services/http-service');
var CartService = require('../services/cart-service');
var CartSummary = require('./cart-summary');
var Modal = require('./modal');
var Pace = require('./pace');
var AlertService = require('../services/alert-service');

var Cart = {
  add: function add(params, event) {
    params = params || {};
    var numOfProducts = (params.sku || []).length;

    Pace.open();

    CartService.add(params.sku, params.deliveredPhysicalStore, params.seller)
      .then(HTTPService.handleClientError)
      .then(function (data) {
        params.numOfProducts = numOfProducts;

        $(document).trigger('cart:add-product', params);

        if (params.oneclick) {
          return (window.location.href = blz.checkoutUrl || '/sacola/');
        }

        if (params.replace) {
          event.target.outerHTML = params.replace;
        } else if (params.alert) {
          AlertService.open({ msg: 'Seu produto foi adicionado na sacola!', timeout: 7000 });
        } else {
          Modal.open({
            title: 'Já adicionamos na sua sacola!',
            body: data,
            previousFocused: event.target
          });
        }

        CartSummary.setCount(CartSummary.getCountFromStorage() + numOfProducts);
        CartSummary.getSummary();

        if (CartSummary.getCountFromStorage() === 1) {
          $(document).trigger('cart:create');
        }
      })
      .catch(NotificationService.warning)
      .always(Pace.close);
  }
};

function _addToCart(event) {
  event.preventDefault();
  var data = $(this).data() || {};

  if (data.webview && (window.Native || {}).buy) {
    window.Native.buy(data.sku);
  } else {
    Cart.add(data, event);
  }
}

$('body').on('click tap', '.js-add-to-cart', _addToCart);

module.exports = Cart;
